/* eslint-disable no-undef */
/* eslint-disable wrap-iife */
/* eslint-disable no-magic-numbers */
/* eslint-disable max-statements */
( function( $ ) {

    $('.c-card--image-toggle').hover(function(){
        var theimg = $(this).attr('data-img');
        $('.c-supporting-images img').css('opacity', '0');
        $('.c-supporting-images img.' + theimg).css('opacity', '1');
    })

} )( jQuery );



// WEBPACK FOOTER //
// ./src/js/inc/image-swap.js